import React, { useLayoutEffect } from "react";
import "../aseets/css/About.css";
import teamImg from "../aseets/gallery/team3.jpg";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import WorkflowSection from "./WorkflowSection";

gsap.registerPlugin(ScrollTrigger);

const GmAboutHero = () => {
    useLayoutEffect(() => {
        const ctx = gsap.context(() => {

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".gm-about-hero",
                    start: "top 75%",
                },
            });

            /* IMAGE – cinematic zoom out */
            tl.from(".gm-about-hero-image img", {
                scale: 1.15,
                opacity: 0,
                duration: 1.2,
                ease: "power3.out",
            });

            /* TITLE – rise up */
            tl.from(
                ".gm-about-hero-title span",
                {
                    y: 60,
                    opacity: 0,
                    duration: 0.8,
                    stagger: 0.15,
                    ease: "power3.out",
                },
                "-=0.6"
            );

            /* LINE – expand */
            tl.from(
                ".gm-about-hero-line",
                {
                    scaleX: 0,
                    transformOrigin: "center",
                    duration: 0.6,
                    ease: "power2.out",
                },
                "-=0.4"
            );

            /* LOGOS – subtle reveal */
            tl.from(
                ".gm-about-logos span, .gm-about-logos img",
                {
                    y: 20,
                    opacity: 0,
                    duration: 0.5,
                    stagger: 0.1,
                    ease: "power2.out",
                },
                "-=0.3"
            );

        });

        return () => ctx.revert();
    }, []);

    return (
        <>
            <section className="gm-about-hero">
                <div className="gm-about-hero-image">
                    <img src={teamImg} alt="Global Manch Team" />
                </div>

                <div className="gm-about-hero-content">
                    <h1 className="gm-about-hero-title">
                        <span className="team">our team</span> <br />
                        <span>our power</span>
                    </h1>

                    <div className="gm-about-hero-line"></div>

                    <div className="gm-about-logos">
                        <span>Trusted By</span>
                        <div>
                            <img src="/logos/google.png" alt="" />
                            <img src="/logos/shopify.png" alt="" />
                            <img src="/logos/meta.png" alt="" />
                        </div>
                    </div>
                </div>
            </section>


            <WorkflowSection />



        </>

    );
};

export default GmAboutHero;
